// app version
export const APP_VERSION = 'v1.8.0';

// Armazém Geral secret token
export const INTEGRATION_TOKEN_SECRET = 'xGGgyTS5JUr0z92NcSqKKAsQN6mePxSF';
export const AG_BASE_URL =
  'https://ag.luft.com.br/';

export const states = {
  AC: 1,
  AL: 2,
  AP: 3,
  AM: 4,
  BA: 5,
  CE: 6,
  DF: 7,
  ES: 8,
  GO: 9,
  MA: 10,
  MT: 11,
  MS: 12,
  MG: 13,
  PA: 14,
  PB: 15,
  PR: 16,
  PE: 17,
  PI: 18,
  RJ: 19,
  RN: 20,
  RS: 21,
  RO: 22,
  RR: 23,
  SC: 24,
  SP: 25,
  SE: 26,
  TO: 27,
};

export const statesToLabel = {
  [states.AC]: 'AC',
  [states.AL]: 'AL',
  [states.AP]: 'AP',
  [states.AM]: 'AM',
  [states.BA]: 'BA',
  [states.CE]: 'CE',
  [states.DF]: 'DF',
  [states.ES]: 'ES',
  [states.GO]: 'GO',
  [states.MA]: 'MA',
  [states.MT]: 'MT',
  [states.MS]: 'MS',
  [states.MG]: 'MG',
  [states.PA]: 'PA',
  [states.PB]: 'PB',
  [states.PR]: 'PR',
  [states.PE]: 'PE',
  [states.PI]: 'PI',
  [states.RJ]: 'RJ',
  [states.RN]: 'RN',
  [states.RS]: 'RS',
  [states.RO]: 'RO',
  [states.RR]: 'RR',
  [states.SC]: 'SC',
  [states.SP]: 'SP',
  [states.SE]: 'SE',
  [states.TO]: 'TO',
};

export default states;
